import React from "react";
import { Grid } from "@mui/material";
import AllotDialog from "components/allotDialog/AllotDialog";
import profile from "assets/images/ProfileVendor.svg";
import carProfile from "assets/images/RideTrackCar.svg";
import star from "assets/images/smStar.svg";

function AssignedDriver(props) {
  const {
    status,
    tableData,
    submitAssign,
    handleSearch,
    openDialog,
    filterDrivers,
    handleClose,
    onClickAssign,
    assignDriverLoader,
  } = props;
  const pickupDate = tableData?.scheduledTime;
  const handleOnError = (e) => {
    e.target.src = profile;
  };
  const role = localStorage.getItem("role");
  return (
    <Grid md={12} className="padding20">
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <h1 className="font16 fontMedium colorLightBlack">Assigned Driver</h1>
        </Grid>
        {role !== "adminCompany" &&
          status?.toLowerCase() === "booked" &&
          pickupDate > new Date().toISOString() &&
          !tableData?.DriverProfile?.driverName && (
            <Grid item>
              <button
                className="assignBtn cursor"
                onClick={() => onClickAssign(tableData)}
              >
                Assign
              </button>
            </Grid>
          )}
        {role !== "adminCompany" &&
          status?.toLowerCase() === "booked" &&
          tableData?.DriverProfile?.driverName && (
            <Grid item>
              <button
                className="assignBtn cursor"
                onClick={() => onClickAssign(tableData, true)}
              >
                Re-Assign
              </button>
            </Grid>
          )}
        {role === "adminCompany" && (status?.toLowerCase() === "booked" ||
          status?.toLowerCase() === "accepted" ||
          status?.toLowerCase() === "dispatched") && (
          <Grid item>
            <button className="cancelTripBtn cursor" onClick={props?.onCancel}>
              Cancel Trip
            </button>
          </Grid>
        )}
        {openDialog && (
          <AllotDialog
            onSearch={handleSearch}
            type={"tripView"}
            openDialog={openDialog}
            allotData={filterDrivers}
            title={props?.isReAssign ? "Re-Assign" : "Available"}
            subtitle={"Pickup location - " + tableData?.sourceAddress}
            titleType={"Driver"}
            placeholder={"Search driver"}
            handleClose={handleClose}
            submittAssign={submitAssign}
            loader={assignDriverLoader}
          />
        )}
      </Grid>
      <div className="flexAlignCenter">
        <img
          src={
            tableData?.DriverProfile?.avtar &&
            tableData?.DriverProfile?.avtar !== null
              ? tableData?.DriverProfile?.avtar?.url
              : profile
          }
          alt="profile"
          className="assignedDriverImg"
          onError={handleOnError}
        />
        {tableData?.DriverProfile !== null ? (
          <div className="marginLeft16">
            <h1 className="font20 fontMedium marginBlock0">
              {tableData?.DriverProfile?.driverName}
              <span>
                {tableData?.DriverProfile?.rating && (
                  <img
                    src={star}
                    alt="star"
                    className="feedbackStar marginLeft10 marginRight6"
                  />
                )}
                {tableData?.DriverProfile?.rating &&
                  tableData?.DriverProfile?.rating !== null &&
                  tableData?.DriverProfile?.rating}
              </span>
            </h1>
            <p className="font16 fontNormal colorGrey marginBlock0">
              {tableData?.DriverProfile?.location +
                ", " +
                tableData?.DriverProfile?.mobile}
            </p>
            <p className="font14 fontNormal colorGrey marginBlock0">
              {tableData?.DriverProfile?.vendorName}
              {tableData?.DriverProfile?.subVendorName &&
              tableData?.DriverProfile?.subVendorName !== null
                ? ", "
                : ""}
              {tableData?.DriverProfile?.subVendorName}
            </p>
            <p className="font14 fontNormal colorGrey marginBlock0">
              {(tableData?.DriverProfile?.tripCount &&
              tableData?.DriverProfile?.tripCount !== null
                ? tableData?.DriverProfile?.tripCount
                : "0") + " Trips Completed"}
            </p>
          </div>
        ) : (
          <div>
            <p className="font14 fontSemi marginBlock0 marginLeft16">
              Not Assign
            </p>
          </div>
        )}
      </div>

      <h1 className="font16 fontMedium colorLightBlack marginTop45 marginBottom16">
        Assigned Vehicle
      </h1>
      <div className="flexAlignCenter">
        <img
          src={
            tableData?.DriverProfile?.Vehicle?.avtar?.url
              ? tableData?.DriverProfile?.Vehicle?.avtar?.url
              : carProfile
          }
          alt="profile"
          className="assignedDriverImg"
          onError={handleOnError}
        />
        {tableData?.DriverProfile?.Vehicle &&
        tableData?.DriverProfile?.Vehicle !== null ? (
          <div className="marginLeft16">
            <h1 className="font20 fontMedium marginBlock0">
              {tableData?.DriverProfile?.Vehicle?.carModel || " "}
            </h1>
            <p className="font16 fontNormal colorGrey marginBlock0">
              {tableData?.DriverProfile?.Vehicle
                ? tableData?.DriverProfile?.Vehicle?.carType +
                  ", " +
                  tableData?.DriverProfile?.Vehicle?.regNumber +
                  " " +
                  (tableData?.DriverProfile?.Vehicle?.color
                    ? tableData?.DriverProfile?.Vehicle?.color
                    : "")
                : " "}
            </p>
            <p className="font14 fontNormal colorGrey marginBlock0">
              {(tableData?.DriverProfile?.Vehicle &&
              tableData?.DriverProfile?.Vehicle?.tripCount
                ? tableData?.DriverProfile?.Vehicle?.tripCount
                : "0") + " Trips Completed"}
            </p>
          </div>
        ) : (
          <div>
            <p className="font14 fontSemi marginBlock0 marginLeft16">
              Not Assign
            </p>
          </div>
        )}
      </div>
    </Grid>
  );
}

export default AssignedDriver;
